import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=23bd8c3c&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=23bd8c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd8c3c",
  null
  
)

export default component.exports